<template>
  <QS-scroller-box>
    <TopPreview
      :dataList="orderInfoConfig.list"
      :model="orderInfoConfig.model"
    />
    <QS-h4-title title="合同签署" />

    <contractSigningForm
      ref="contractRef"
      :orderId="orderId"
      :rentCategory="rentCategory"
      @signingChange="signingChange"
      :isRenewOrder="true"
    />

    <!-- 司管模块 -->
    <DriverManager
      :dm="driverManager"
      mode="edit"
      showSave
      :orderId="orderId"
    />

    <template slot="bottomAction">
      <el-button @click="previousStep" :loading="prevBtnLoading">上一步</el-button>
      <el-button v-if="signChannel === SIGN_CHANNEL_MAP.ONLINE" @click="handleBack">返回</el-button>
      <el-button v-if="signChannel === SIGN_CHANNEL_MAP.OFFLINE" @click="handleCancel">取消</el-button>
      <el-button
        type="primary"
        :loading="confirmLoading"
        @click="handleConfirm"
        >
        确认订单签署信息
      </el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
import { getRentOrderDetail } from '@/api/domain/underLease'
import { confirmContract } from '@/api/domain/orders'
import { mixin } from '../../mixins/orderConfirm'
import TopPreview from '@/pages/orders/signContract/add/personalSignContract/components/TopPreview.vue'
import DriverManager from '@/components/DriverManager/index.vue'
import contractSigningForm from '@/pages/orders/components/contractSigningForm/index.vue'
import { SIGN_CHANNEL_MAP } from '@/pages/orders/components/contractSigningForm/config/enum.js'

export default {
  mixins: [mixin],
  props: ['renewalOrderDataList', 'prevBtnLoading'],
  components: {
    DriverManager,
    contractSigningForm,
    TopPreview,
  },
  data() {
    return {
      orderId: null, // 续签合同ID
      confirmLoading: false,
      queries: JSON.parse(decodeURIComponent(this.$route.query.query || '{}')),
      orderData: {},
      driverManager: null,
      customerId: '',
      carId: '',
      SIGN_CHANNEL_MAP,
      signChannel: null,
      rentCategory: '',
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    orderInfoJumpRender(type) {
      if (!type) {
        return ''
      }
      if (type === 'customer' && !this.customerId) {
        return ''
      }
      if (type === 'car' && !this.orderInfoConfig.model.plateNo) {
        return ''
      }
      const routeParams = {
        customer: {
          path: '/driver/customerManage/detail',
          query: {
            id: this.customerId,
            customerType: 1,
          },
          text: '查看客户信息',
        },
        car: {
          path: '/vehicle/vehicleManage/detail',
          query: {
            id: this.carId,
            plateNo: this.orderInfoConfig.model.plateNo,
          },
          text: '查看车辆及保单信息',
        },
      }
      const data = {
        on: {
          click: () =>
            this.$router.push({
              path: routeParams[type].path,
              query: routeParams[type].query,
            }),
        },
      }
      return (
        <elButton type="text" {...data}>
          {routeParams[type].text}
        </elButton>
      )
    },
    async init() {
      const { orderId } = this.queries
      const originOrder = this.renewalOrderDataList[0]
      this.orderId = orderId || originOrder.id

      let orderInfo
      try {
        if (orderId) {
          orderInfo = await this.getRentOrderDetail(orderId)
        } else {
          orderInfo = originOrder
          this.rentCategory = originOrder.rentCategory
        }
      } catch (err) {
        console.error(err)
      }
      if (orderInfo) {
        this.backfill(orderInfo)
      }

      this.orderData = orderInfo
    },
    handleBack() {
      this.$refreshBack()
    },
    handleCancel() {
      this.$confirm('取消后可在「订单续约」列表继续操作订单确认流程，点击确定返回列表', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refreshBack(false)
        this.$router.replace({
          name: 'order_renewal',
        })
      }).catch(() => null)
    },
    // 提交续约
    handleConfirm() {
      const contractData = this.$refs.contractRef.validAndGetData()
      if (!contractData) return
      this.confirmLoading = true
      confirmContract({
        orderId: this.orderId,
        ...contractData,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success('续约成功')
          setTimeout(() => {
            this.$refreshBack(true)
            this.$router.replace({
              name: 'order_renewal',
            })
          }, 1200)
        }
      }).catch((err) => {
        if (err.code === 22029) {
          this.$message.error(err.msg)
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    // 更新签署方式
    signingChange(signChannel) {
      this.signChannel = signChannel
    },
    // 上一步
    previousStep() {
      // 返回创建好的订单ID
      this.$emit('previousStep', this.orderId)
    },

    // 获取订单详情
    async getRentOrderDetail(orderId) {
      let res
      try {
        res = await getRentOrderDetail({
          orderId,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return
      const { code, data } = res
      if (code === 1 && data) {
        this.rentCategory = data.rentCategory
        return data
      }
    },
    backfill(data) {
      const orderInfoModel = {
        customerName: data.customerName || '',
        plateNo: data.plateNo || '',
        modelName: data.modelName || '',
        brandName: data.brandName || '',
        seriesName: data.seriesName || '',
        rentDate:
          data.startDate && data.endDate
            ? `${data.startDate}~${data.endDate}`
            : '',
        rentAmount: (data.rentAmount || '') + (data.rentAmount ? '元' : ''),
        totalDeposit:
          (data.totalDeposit || '') + (data.totalDeposit ? '元' : ''),
      }
      this.orderInfoConfig.model = orderInfoModel

      this.orderId = data.id || null

      this.customerId = data.customerId || ''
      this.carId = data.carId || ''
      const manager = { ...data?.manager }

      for (const key in manager) {
        // eslint-disable-next-line no-prototype-builtins
        if (manager.hasOwnProperty(key) && key === 'avatar') {
          try {
            const avatar = JSON.parse(manager.avatar)
            manager.avatar = avatar?.[0]
          } catch (error) {
            manager.avatar = data?.manager?.avatar
          }
        }
      }
      this.driverManager = manager || ''
    },
  },
  created() {
    this.init()
  },
  activated() {
    this.init()
  },
}
</script>
